exports.components = {
  "component---src-containers-establishment-tsx": () => import("./../../../src/containers/establishment.tsx" /* webpackChunkName: "component---src-containers-establishment-tsx" */),
  "component---src-containers-not-found-tsx": () => import("./../../../src/containers/notFound.tsx" /* webpackChunkName: "component---src-containers-not-found-tsx" */)
}

